(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-desc-template"]) return;
  try {
    
  function fix_options(){}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  function fix_options(){}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-list"] && !Shopify.designMode) return;
  try {
    
  function fix_options(){}

  } catch(e) { console.error(e); }
})();
})();
